<template>
      <div class="little-title">
          <span class="space"></span>
          <span class="vm">{{title}}</span>
      </div>
</template>


<script>
    export default{
        props:{
            title:{
                type:String,
                default:''
        }
        },
        data(){
            return {
            }
        },
    }
</script>

<style lang="less" scoped>
.little-title{
    .space{
        height: 16px;
        background: @blue;
        width: 3px;
        display: inline-block;
        vertical-align: middle;
        margin-right:10px; 
    }
}

</style>
